module.exports = __webpack_public_path__ + "img/Corriander.2b20a7aa.svg";